/**
 * Centraliza la configuración de runtime para que no dependas exclusivamente de .env.
 * Puedes editar estos valores directamente o sobreescribirlos con variables VITE_*.
 * 
 * ✅ PRE-DEPLOY: Configurar variables de entorno en producción:
 * - VITE_API_BASE_URL
 * - VITE_IDENTITY_URL
 * - VITE_FINANCE_URL
 * - VITE_DOCUMENTS_URL
 * - VITE_OIDC_AUTHORITY
 * - VITE_OIDC_CLIENT_ID
 */
// ============================================================================
// VALORES POR DEFECTO (desarrollo)
// ============================================================================
const DEFAULT_OIDC_AUTHORITY = "https://sso.pre.mojito360.com/";
const DEFAULT_OIDC_CLIENT_ID = "vision_web";
const DEFAULT_OIDC_REDIRECT_PATH = "auth/callback";
//const DEFAULT_OIDC_SCOPE = "nemesis_api";
const DEFAULT_OIDC_SCOPE = "vision_api";
// URLs de API por servicio
const DEFAULT_API_BASE_URL = "https://nemesis.dev.mojito360.com/core/api/";
const DEFAULT_IDENTITY_URL = "https://nemesis.dev.mojito360.com/identity";
const DEFAULT_FINANCE_URL = "https://vision.dev.mojito360.com/core/";
const DEFAULT_DOCUMENTS_URL = "https://nemesis.dev.mojito360.com/documents/api/";
// Supabase (para storage de avatares)
const VITE_SUPABASE_URL = "https://mvpnmnoelnfcabndkfcn.supabase.co";
const VITE_SUPABASE_ANON_KEY =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im12cG5tbm9lbG5mY2FibmRrZmNuIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjMxMzU2MzMsImV4cCI6MjA3ODcxMTYzM30.1qbkw2Trh2Li8p0q2ZxVhl-DILShIA2BzqkJZUOOcvM";
// Licencia MUI Pro
const DEFAULT_MUI_LICENSE_KEY =
  "c1d52854d011b2bb42b92e87541e1430Tz0xMjIyOTksRT0xNzk1NjUxMTk5MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1RMy0yMDI0LEtWPTI=";
// ============================================================================
// CONFIGURACIÓN EXPORTADA
// ============================================================================
export const appConfig = {
  // API URLs - usar variables de entorno si están disponibles
  apiUrlBase: import.meta.env.VITE_API_BASE_URL || DEFAULT_API_BASE_URL,
  identityUrl: import.meta.env.VITE_IDENTITY_URL || DEFAULT_IDENTITY_URL,
  financeUrl: import.meta.env.VITE_FINANCE_URL || DEFAULT_FINANCE_URL,
  documentsUrl: import.meta.env.VITE_DOCUMENTS_URL || DEFAULT_DOCUMENTS_URL,
  // MUI License
  muiLicenseKey: import.meta.env.VITE_MUI_LICENSE_KEY || DEFAULT_MUI_LICENSE_KEY,
  // OIDC
  oidc: {
    authority: import.meta.env.VITE_OIDC_AUTHORITY || DEFAULT_OIDC_AUTHORITY,
    clientId: import.meta.env.VITE_OIDC_CLIENT_ID || DEFAULT_OIDC_CLIENT_ID,
    redirectPath: DEFAULT_OIDC_REDIRECT_PATH,
    scope: DEFAULT_OIDC_SCOPE,
  },
  // Supabase
  supabase: {
    url: import.meta.env.VITE_SUPABASE_URL || VITE_SUPABASE_URL,
    anonKey: import.meta.env.VITE_SUPABASE_ANON_KEY || VITE_SUPABASE_ANON_KEY,
  },
  // Helpers para construir URLs
  getApiUrl: (endpoint: string) => {
    const base = import.meta.env.VITE_API_BASE_URL || DEFAULT_API_BASE_URL;
    return `${base.replace(/\/$/, '')}/${endpoint.replace(/^\//, '')}`;
  },
  getIdentityUrl: (endpoint: string) => {
    const base = import.meta.env.VITE_IDENTITY_URL || DEFAULT_IDENTITY_URL;
    return `${base.replace(/\/$/, '')}/api/${endpoint.replace(/^\//, '')}`;
  },
  getFinanceUrl: (endpoint: string) => {
    const base = import.meta.env.VITE_FINANCE_URL || DEFAULT_FINANCE_URL;
    return `${base.replace(/\/$/, '')}/api/${endpoint.replace(/^\//, '')}`;
  },
  getDocumentsUrl: (endpoint: string) => {
    const base = import.meta.env.VITE_DOCUMENTS_URL || DEFAULT_DOCUMENTS_URL;
    return `${base.replace(/\/$/, '')}/${endpoint.replace(/^\//, '')}`;
  },
};
